import React, { useState } from "react";
import moment from "moment";
import { FcCalendar } from "react-icons/fc";
import { FaEye } from "react-icons/fa";
import { notification } from "antd";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { countryList } from "../../../../helperFuncs/countryList";
import { CustomButton } from "../../../CustomButton";
import ViewPaymentPlan from "../../../ProjectManager/PaymentPlan/modals/ViewPaymentPlan";
import { errorBlock } from "../../../../controllers/errorBlock";
import axios from "../../../../utils/axios";
import { channelController } from "../../../../controllers/channelController";
import { themeColor } from "../../../../constant/color";

const PlansCard = ({ data, customer }) => {
  const [loading, setloading] = useState(false);
  const [selectplan, setselectplan] = useState({});
  const [plandetails, setplandetails] = useState({});
  const [open, setopen] = useState(false);
  const { country } = useSelector((state) => state.projectSite);
  const { username } = useSelector((state) => state.userDetails);
  const { name: domainname } = useSelector((state) => state.projectSite);

  const buyPlan = async (data) => {
    try {
      setloading(true);
      let res = await axios.post("/vending/payment/acquiretransactionid", {
        planalias: data?.planalias,
        channelid: customer?.meter,
        paymentgateway: "sales agent",
        amount: data.amount,
        creator: username,
        currency: countryList[country]["Currency Code"],
      });

      const result = channelController(res);

      if (result.type !== "success") {
        toast.error(result.message);
        setloading(false);
        return;
      }

      if (!("transactionid" in result.message)) {
        toast.error(result.message?.response);
        setloading(false);
        return;
      }

      let tranxres = await axios.post("/vending/payment/committransaction", {
        transactionid: result.message?.transactionid,
        transactiontopic: domainname + "/mqtt_" + username,
      });

      const tranxresult = channelController(tranxres);

      if (tranxresult.type !== "success") {
        toast.error(tranxresult.message);
        setloading(false);
        return;
      }

      if (tranxresult.message.status == "Request Sent") {
        notification.success({
          message: "Success",
          description: tranxresult.message.status,
        });
      } else {
        toast.error(tranxresult.message.status);
      }

      setloading(false);
    } catch (error) {
      errorBlock(error);
      setloading(false);
    }
  };

  return (
    <div className="md:hidden">
      {open && (
        <ViewPaymentPlan open={open} setopen={setopen} details={plandetails} />
      )}
      <div className="grid grid-cols-1 gap-4">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="border rounded-md p-3 shadow-sm">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-medium text-lg">{item.planalias}</h3>
                <div
                  onClick={() => {
                    setplandetails(item);
                    setopen(true);
                  }}
                  className="border-[1px] cursor-pointer rounded border-gray-400 text-[12px] font-light p-2"
                >
                  <FaEye size={15} />
                </div>
              </div>

              <div className="mb-2">
                <p className="text-gray-600 text-sm">{item.description}</p>
              </div>

              <div className="flex items-center mb-2">
                <span className="text-gray-600 mr-2">Amount:</span>
                <span className="font-medium">
                  {`${
                    countryList[country]["Currency Code"]
                  } ${item.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}`}
                </span>
              </div>

              <div className="flex items-center mb-3">
                <div className="px-1">
                  <FcCalendar size={18} />
                </div>
                <div className="text-sm text-gray-600">
                  {moment(item.datecreated).format("lll")}
                </div>
              </div>

              <CustomButton
                color={themeColor.secondary}
                loading={selectplan == item.planalias ? loading : false}
                disabled={loading}
                onClick={() => {
                  setselectplan(item.planalias);
                  buyPlan(item);
                }}
                className="border-[1px] w-full cursor-pointer rounded border-secondary text-[12px] text-secondary font-light px-4 py-2"
              >
                {selectplan == item.planalias && loading ? "" : "Buy plan"}
              </CustomButton>
            </div>
          ))
        ) : (
          <div className="text-center py-4">
            <p>No plans available for this meter</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlansCard;
